import {SeatUsage} from "../../services/SeatManager";
import {SubscriptionSeatsService} from "../../shared/services/SubscriptionSeatsService";
import {getPaddlePriceIds} from "../../utils/priceIds";
import {CheckoutPeriod} from "../types";
import {getCurrentCheckoutPeriod} from "@stores/client";
import {ClientInApp} from "../../shared/types/SubscriptionTypes";


export const getInitialSeatsCount= (client: ClientInApp, seatUsage: SeatUsage) => {
    // Get current purchased location seats from subscription items
    const currentPurchased = SubscriptionSeatsService.getPurchasedSeats(client, getPaddlePriceIds());

    const period: CheckoutPeriod = getCurrentCheckoutPeriod(client);

    // Return the current purchased amount as the initial value
    return {
        locationSlots: Math.max(currentPurchased.locationSlots, seatUsage.locations.current),
        userSeats: Math.max(currentPurchased.userSeats, seatUsage.users.current),
        purchasedLocationSlots: currentPurchased.locationSlots,
        purchasedUserSeats: currentPurchased.userSeats,
        period,
    };
}
